import request from '@/utils/request'

// 合同验收审批主表
export function selectInfoById(headId) {
  return request({
    url: `/api/coop/cmContractAccepteApply/selectInfoById/${headId}`,
    method: 'get'
  })
}
